module.exports = __webpack_public_path__ + "img/General waste.a4e2f491.svg";